import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import { GlobalVariables } from '../global';
import { handleApiErrors } from '../_utils/api.util';

@Injectable()
export class FeedbackStandEndpointsService {
  private basicUrl = GlobalVariables.BASE_API_URL + '/api/v1/branches';
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
  ) {}

  getFeedbackStandData(id) {
    let url = this.basicUrl + '/' + this.route.snapshot.params['branchId'] + '/feedback_stands/' + id;
    return this.http.get(url).pipe(catchError((err) => handleApiErrors(err)));
  }

  generateFeedback(feedbackData) {
    let url = this.basicUrl + '/' + this.route.snapshot.params['branchId'] + '/feedbacks/stand_feedback';
    return this.http.post(url, { feedback: feedbackData }).pipe(catchError((err) => handleApiErrors(err)));
  }
}
